$(document).ready(function(){
  $("#flipers").click(function(){
    $("#panelner").slideToggle("fast");
  });
});
$(document).ready(function(){
  $("#flipersfeatured").click(function(){
    $("#panelnerfeatured").slideToggle("fast");
  });
});
$(document).ready(function(){
  $("#flipersdisclaimer").click(function(){
    $("#panelnerdisclaimer").slideToggle("fast");
  });
});
$(document).ready(function(){
  $(".chartshow").click(function(){
    $(".chartbox").show();
  });
});
$(document).ready(function(){
  $(".crossbtn").click(function(){
    $(".chartbox").hide();
  });
});
$(document).ready(function(){
  $(".footertitleshow").click(function(){
    $(".footercontenthide").slideToggle("slow");
  });
});
$(document).ready(function(){
  $(".footertitlepolicy").click(function(){
    $(".footercontentpolicyhide").slideToggle("slow");
  });
});
$(document).ready(function(){
  $(".footertitlefirst").click(function(){
    $(".footercontentfirsthide").slideToggle("slow");
  });
});



$(document).ready(function(){
$('.rslides').slick({
    infinite: true,
    slidesToShow: 4,  
    arrows: false,
    autoplay: true,
    slidesToScroll: 2,
    autoplaySpeed: 1,
    speed: 6000,
    cssEase: 'linear',
    waitForAnimate: false,
    pauseOnFocus: false, 
    pauseOnHover: false,

    responsive: [
    {
      breakpoint: 768,
      settings: {
  slidesToShow: 3,
      }
    },
       {
      breakpoint: 420,
      settings: {
  slidesToShow: 2,
      }
    }
  ]
});
});












